module.exports = __webpack_public_path__ + "img/ranek.e7a4871b.svg";